import { Box } from "@outschool/backpack";
import React from "react";

interface OtherListingsMaskProps {
  hidden: boolean;
  children: React.ReactNode;
}
export default function OtherListingsMask({
  hidden,
  children,
}: OtherListingsMaskProps) {
  return (
    <Box
      sx={{
        position: "relative",
        transition: "max-height 1s",

        "&:after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          height: "100%",
          width: "100%",
          content: '""',
          pointerEvents: "none",
          background:
            "linear-gradient(to bottom, rgba(255,255,255,0.5), white 32rem)",
          opacity: 0,
          transition: "opacity 1s",
        },

        ...(hidden && {
          maxHeight: "32rem",
          overflow: "hidden",
          "&::after": {
            pointerEvents: "all",
            opacity: 1,
            zIndex: 1,
          },
        }),
      }}
    >
      {children}
    </Box>
  );
}
